export default (text: string, length: number) => {
  const short = text?.slice(0, length);
  if (text?.length > length) return short + '...';
  return text;
};
